/**
 * The HM surface threads the current query string (tenant selection etc.) through every internal link and
 * redirect. One shared helper instead of the four hand-rolled copies: `?…` when params exist, else ''.
 */
export const toSearchSuffix = (searchParams: URLSearchParams): string => {
  const value = searchParams.toString();
  return value ? `?${value}` : '';
};
